// @flow
import type { Saga } from "redux-saga";

import enterEmailJourney from "shared/utilities/segmentActions/enterEmailJourney";

export default function* enterEmailJourneySaga(): Saga<void> {
  enterEmailJourney();
}
